module.exports = __webpack_public_path__ + "static/track_your_progress-ca049c7f395052d8055748917110a3c7.jpg";